// Autogenerated file
export const workloadStatusesEnum = {
    NotStarted: "NotStarted",
    Running: "Running",
    Completed: "Completed",
    Faulted: "Faulted",
};
export const workloadStatuses = [
    { label: "Not started", value: "NotStarted" },
    { label: "Running", value: "Running" },
    { label: "Completed", value: "Completed" },
    { label: "Faulted", value: "Faulted" },
];
